// @flow
import * as React from 'react';
import { Field, FieldProps } from 'formik';
import { Box } from 'grommet';
import { FormattedMessage, defineMessages } from 'react-intl';
import * as Yup from 'yup';
import DatePicker, { MAX_TIMESTAMP, MIN_TIMESTAMP } from './DatePicker/DatePicker';


type Props = {
    field: {
        name: string
    },
    form: {
        values: Object
    },
    label: string,
    required: boolean
}

const defaultProps = {
    displayFormat: 'L',
    valueFormat: 'YYYY-MM-DD',
    mapFormatRegex: /(\w+|\d+)/,
    years_span: undefined,
    min: new Date(MIN_TIMESTAMP).toISOString(),
    max: new Date(MAX_TIMESTAMP).toISOString(),
};

const currentDate = Date.now();

const DateRangePicker = (props: Props) => {
    const {
        field: { name },
        form: { values },
        label,
        required,
    } = props;

    if (values[`${name}_after`] && values[`${name}_before`] && values[`${name}_after`] > values[`${name}_before`]) {
        values[`${name}_before`] = values[`${name}_after`];
    }

    if (values[`${name}_after`] && values[`${name}_before`] && values[`${name}_after`] > values[`${name}_before`]) {
        values[`${name}_before`] = values[`${name}_after`];
    }
    
    return (
        <Box
            direction="row"
            style={{
                display: 'flex', justifyContent: 'space-between', alignContent: 'stretch', minHeight: 'auto',
            }}
            align="end"
        >
            <Box width="47%">
                <Field name={`${name}_after`}>
                    {
                        (field: FieldProps) => (
                            <DatePicker
                                {...field}
                                required={required}
                                min={defaultProps.min}
                                max={new Date(currentDate).toISOString()}
                                label={
                                    (
                                        <>
                                            {label}
                                            {':'}
                                        </>
                                    )}
                            />
                        )
                    }
                </Field>
            </Box>
            <Box width="47%">
                <Field name={`${name}_before`}>
                    {
                        (field: FieldProps) => (
                            <DatePicker
                                {...field}
                                required={required}
                                min={values[`${name}_after`] || defaultProps.min}
                                max={new Date(currentDate).toISOString()}
                                label={<FormattedMessage id="filters-to" defaultMessage="To:" />}
                            />
                        )
                    }
                </Field>
            </Box>
        </Box>
    );
};

const messages = defineMessages({
    required: {
        id: 'datefrompicker-required',
        defaultMessage: 'This field is required.',
    },
});

DateRangePicker.getValidationSchema = (field: { validation: Object }) => {
    if (field.validation.required) {
        return Yup.string().required(messages.required).nullable();
    }

    return Yup.string().nullable();
};

export default DateRangePicker;
